export default function fetchImages(productCodes) {
  const headers = new Headers({
    "Content-Type": `application/json;charset=UTF-8`,
  });
  return fetch(`/trsonline/products/images/batch`, {
    method: `POST`,
    credentials: `include`,
    body: JSON.stringify(productCodes),
    headers
  }).then((response: Response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response.status;
    }
  });
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/image-fetch/fetchImages.js